export default __webpack_public_path__ + "static/media/portadavideoplanificacion4.fa4b03d3.png";